var map = {
	"./Andre-forbrugerprodukter.jpg": "d2bc",
	"./Desinfektions--og-Konserveringsmidler.jpg": "20c3",
	"./Diverse.jpg": "83bd",
	"./Elektronik,-IT-udstyr-og-Batterier.jpg": "952a",
	"./Gasser-Klimagasser-og-Spraydåser.jpg": "673c",
	"./Gødning.jpg": "ba54",
	"./Kemiske-Blandinger-og-Gifte.jpg": "7e5d",
	"./Kosmetik-og-personlig-pleje.jpg": "5c7e",
	"./Legetøj-og-Børneprodukter.jpg": "1be2",
	"./Pesticider.jpg": "b2fa",
	"./Skadedyrsbekæmpelse.jpg": "810f",
	"./Tøj,-Sko-og-Acessories.jpg": "363a",
	"./Vaske-og-Rengøringsmidler.jpg": "de5a",
	"./chemistry-icon.svg": "f610"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce2c";